const farmerSidebar = [
    {
      link: "/PersonalDashboard",
      icon: "dashboard",
      name:"Dashboard",
    },
    {
        link: "/GrowBot",
        icon: "bot",
        name:"GrowBot",
    },
    {
        link: "/PlantSimulation",
        icon: "sim",
        name:"Plant Condition Simulation",
    },
    {
        link: "/Forum",
        icon: "forum",
        name:"Forum",
    },
    {
        link: "/ClassesEvents",
        icon: "class",
        name:"Classes and Events",
    },
    {
        link: "/Market",
        icon: "market",
        name:"Marketplace",
    }
  ];

  export default farmerSidebar;